import { ChangeEvent } from "react"

import { Form } from "react-bootstrap"

import PendingClinicalTest from "../../../api/OrphanedResults/Models/PendingClinicalTest"
import FormatDate from "../../../formatters/FormatDate"

interface PendingClinicalTestProps {
  test: PendingClinicalTest
  selected?: boolean
  highlighted?: boolean
  disabled?: boolean
  hideCheckbox?: boolean
  onSelect: (testId: string) => void
}

function PendingClinicalTestRow({
  test,
  disabled = false,
  hideCheckbox = false,
  highlighted = false,
  selected = false,
  onSelect,
}: PendingClinicalTestProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSelect(e.target.value)
  }

  const isLess90Days = () => {
    const createdDate = test.DateOrdered
    if (createdDate !== undefined) {
      const timeDiff = new Date().getTime() - createdDate.getTime()
      const daysDiff = Math.round(timeDiff / (1000 * 3600 * 24))
      return daysDiff < 90
    }
    return false
  }

  const rowClassName = () => {
    const classes: string[] = []
    if (highlighted && isLess90Days() && !disabled) classes.push("bg-row-highlight")

    return classes.join(" ")
  }

  return (
    <tr className={rowClassName()} title="">
      <td className="align-middle">
        {!hideCheckbox && (
          <Form.Check
            type="checkbox"
            name="pending-clinical-test-detail"
            id={`pct_${test.TestDetailClinicalID}`}
            className="abc-checkbox abc-checkbox-primary d-flex justify-content-center align-middle"
            value={test.TestDetailClinicalID}
            label=""
            disabled={disabled}
            checked={selected}
            readOnly
            onChangeCapture={handleChange}
          />
        )}
      </td>
      <td>{test.FormFoxTestAN}</td>
      <td title={test.Reason}>{test.ReasonDescription}</td>
      <td>{test.SampleType}</td>
      <td>{FormatDate(test.DateOrdered)}</td>
    </tr>
  )
}

export default PendingClinicalTestRow
